export default "__VITE_ASSET__Bo_c40DR__"